import React from 'react';

interface LogoutIconProps {
  size?: number;
  color?: string;
}

export const LogoutIcon: React.FC<LogoutIconProps> = ({ 
  size = 20, 
  color = '#fff' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <path 
        fill={color} 
        d="M4.167 17.5q-.688 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177V4.167q0-.688.49-1.177t1.177-.49H10v1.667H4.167v11.666H10V17.5zm9.166-3.333-1.146-1.209 2.126-2.125H7.5V9.167h6.813l-2.126-2.125 1.146-1.209L17.5 10z"
      />
    </svg>
  );
};

